// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2GIAK","errors":"Errors_errors__ICxtH"};